import script from "./CardapioEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardapioEdit.vue?vue&type=script&lang=ts&setup=true"

import "./CardapioEdit.vue?vue&type=style&index=0&id=68848aeb&lang=css"

const __exports__ = script;

export default __exports__